// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_AcceptanceDetailResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_AcceptanceDetailResponse — GET
 * /subscriptions/admin-terms/acceptance/{id}.
 *
 * The heavy read: one acceptance with the full agreement text as signed and the
 * signature image. Separate from the listing so a page of rows never carries
 * either payload.
 */
import type { SubscriptionTerms_AcceptanceRow } from './SubscriptionTerms_AcceptanceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubscriptionTerms_AcceptanceDetailResponseDados {
row: SubscriptionTerms_AcceptanceRow
termo_conteudo: string
assinatura_png: string
assinatura_pontos: number
assinatura_ms: number
user_agent: string
}

export type SubscriptionTerms_AcceptanceDetailResponse = ApiResponse<SubscriptionTerms_AcceptanceDetailResponseDados>;

registerResponseContract('SubscriptionTerms_AcceptanceDetailResponse', {
  row: {
    type: 'object',
    required: false,
    fields: {
      id:                { type: 'number',  required: true },
      term_id:           { type: 'number',  required: false },
      franquia_id:       { type: 'number',  required: false },
      subscription_id:   { type: 'number',  required: false },
      franquia_nome:     { type: 'string',  required: false },
      termo_titulo:      { type: 'string',  required: false },
      termo_versao:      { type: 'string',  required: false },
      plan_id:           { type: 'number',  required: false },
      termo_plano:       { type: 'string',  required: false },
      termo_idioma:      { type: 'string',  required: false },
      term_variant_id:   { type: 'number',  required: false },
      content_sha256:    { type: 'string',  required: false },
      assinatura_sha256: { type: 'string',  required: false },
      assinatura_metodo: { type: 'string',  required: false },
      accepted_by_sub:   { type: 'string',  required: false },
      accepted_by_email: { type: 'string',  required: false },
      ip_address:        { type: 'string',  required: false },
      created_at:        { type: 'string',  required: false },
    },
  },
  termo_conteudo:    { type: 'string',  required: true },
  assinatura_png:    { type: 'string',  required: true },
  assinatura_pontos: { type: 'number',  required: false },
  assinatura_ms:     { type: 'number',  required: false },
  user_agent:        { type: 'string',  required: false },
})
